<template>
	<div style="margin-top: 40px;">
		<el-form :model="itemForm" style="text-align: left;" v-if="dialogToAdd">
			<div style="text-align: center;">
				<samp style="">折扣后价格</samp>
				<h1 style="text-align: center;">¥850</h1>
			</div>
			<div style="margin-bottom: 50px; margin-top: 40px;">
				<h3><samp style="color: #666; font-size: 16px;">实际消费：</samp>¥1000</h3>
				<h4 style="margin-top: 20px; margin-bottom: 20px;"><samp
						style="color: #666; font-size: 16px;">享受折扣：</samp>8.5</h4>
				<h4><samp style="color: #666; font-size: 16px;">商户名称：</samp>台州市健民餐饮有限公司</h4>
			</div>
			<el-form-item label="请输入核验密码" label-position="left" style="text-align: left;">
				<el-input type="number" style="font-size: 30px;" v-model="itemForm.name"></el-input>
			</el-form-item>

			<div style="text-align:center;">
				<el-button style="width: 100%; height: 60px; font-size: 18px;" @click="hy" type="primary">
					核验订单
				</el-button>
			</div>
		</el-form>
		<div v-else="dialogToAdd" style="text-align: center;padding-top: 60%;">
			<samp style="font-size: 40px; color: #108040;"><i class="el-icon-success"></i></samp>
			<h2>核验成功</h2>
		</div>
	</div>
</template>


<script>
	import QRCode from 'qrcodejs2'
	export default {
		data() {
			return {
				dialogToAdd: true,
				itemForm: {
					name: '',
					tel: '',
				},
				data_list_a: {
					data: [],
					page: 1,
					v: false,
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
					name: '1',
					label: ''
				}]
			}
		},
		mounted() {

		},
		methods: {
			hy() {
				this.dialogToAdd = false;

			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/hy.vue